import { BenefitDTO, BikeleasingV2BenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';
import { isBikeleasingSetupPending } from '../useBikeleasingDetails';

export class BikeleasingBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const bikeleasingDetails = activeBenefit.details as BikeleasingV2BenefitDetailsDTO;

    const hasBikeleasingUser = !!bikeleasingDetails.bikeleasingEmployeeInformation.bikeleasingEmployeeCode;
    const hasBikeleasingContract = !!bikeleasingDetails.bikeleasingContract.length;

    const setupPending = isBikeleasingSetupPending(bikeleasingDetails);

    let descriptionKey: string | undefined;

    if (setupPending) {
      descriptionKey = `benefitModule:benefit.${activeBenefit.benefit}.description.setup`;
    } else if (!hasBikeleasingUser) {
      descriptionKey = `benefitModule:benefit.${activeBenefit.benefit}.description.register`;
    } else if (!hasBikeleasingContract) {
      descriptionKey = `benefitModule:benefit.${activeBenefit.benefit}.description.order`;
    }

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: `/${activeBenefit.benefit.toLowerCase()}`,
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: descriptionKey,
      descriptionValues: { total: bikeleasingDetails.bikeleasingCondition?.priceRestrictions?.maxTotalPurchasePriceForAllBikes },
      benefitProgress: !setupPending && bikeleasingDetails.bikeleasingEmployeeInformation?.bikeleasingEmployeeCode ? 100 : 0,
    };
  }
}
